import React, {useEffect, useState} from 'react'
import { Blacked, ModalContent, ModalHeader, ModalInput, ModalSubmit, ModalTitle, ModalWrapper } from '../styles';
import { Icon } from 'CRM/organism/Main/styles';
import { FaChevronLeft } from 'react-icons/fa6';
import { Input, message } from 'antd'
import { ChromePicker } from 'react-color';
import API from 'utils/api';
import { useToken } from 'app/hooks';
import { useStatusList } from 'CRM/hooks/GetStatusList';
import {useIsMobile} from "../IsMobile";

export const StatusEdit = ({ setIsEdit, data }) => {
  const IsMobile = useIsMobile();
  const { data: token } = useToken();
  const { mutate } = useStatusList();
  const [name, setName] = useState(data?.name || '');
  const [color, setColor] = useState(data?.color || '#fff');
  const [desc, setDesc] = useState(data?.desc || '');


  const clickSubmit = () => {
    const shouldEdit = window.confirm(`수정하실 내용이 맞습니까? \n 상태: ${name} \n 색상: ${color} \n 설명: ${desc}`);
    if(shouldEdit) {
      if(name == '') {
        message.error('상태는 필수 입력입니다.')
      } else if (color == '') {
        message.error('색상은 필수 입력입니다.')
      } else {
        API.put('/system/status/' + data?.id, token + '', {
          datas: {
            name: name,
            color: color,
            desc: desc
          }
        })
        .then((res: any) => {
          if (res.result.success) {
            message.success('수정되었습니다');
            mutate();
            setIsEdit(false);
          }
        })
        .catch((err: any) => {})
      }
    }
  }

  return (
    <>
      <Blacked onClick={() => setIsEdit(false)} />
      <ModalWrapper IsMobile={IsMobile}>
        <ModalHeader>
          <Icon onClick={() => setIsEdit(false)}><FaChevronLeft /></Icon>
          <ModalTitle>상태관리 수정</ModalTitle>
          <ModalSubmit onClick={clickSubmit}>저장</ModalSubmit>
        </ModalHeader>
        <ModalContent>
          <ModalInput>
            <label htmlFor='name'>상태명 *</label>
            <Input id='name' type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder='상태를 입력해주세요.' />
          </ModalInput>
          <ModalInput>
            <label htmlFor='color'>색상 *</label>
            <ChromePicker color={color} onChange={color => setColor(color.hex)} />
          </ModalInput>
          <ModalInput>
            <label htmlFor='desc'>설명</label>
            <Input id='desc' type="text" value={desc} onChange={(e) => setDesc(e.target.value)} placeholder='설명을 입력해주세요.' />
          </ModalInput>
        </ModalContent>
      </ModalWrapper>
    </>
  )
}

export default React.memo(StatusEdit);